import React, { useContext, useEffect, useReducer, useMemo } from 'react'

import { Box, IconButton } from '@mui/material'

import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import dayjs from 'dayjs';
import EditTeamModal from './Edit-team-modal';
import Table, { TableHook } from '../../Table';

const url = '/team/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    console.error('Falha ao deletar')

}

const columns = (setState, permissions) => {
    return [
        { field: 'identifier', headerName: 'Identificador', flex: 1, filterType: 'number' },
        { field: 'name', headerName: 'Nome', flex: 1, filterType: 'string' },
        { field: 'created_at', headerName: 'Criado em', flex: 1, filterType: 'daterange',
        valueGetter: ({value}) => {return dayjs(value).format('DD/MM/YYYY HH:mm')} },
        { field: 'members__first_name', headerName: 'Membros', flex: 1, filterType: 'string',
        valueGetter: ({row}) => row.members.map(each=> `${each.first_name} ${each.last_name}` ).join(', ') },
        {
            field: 'actions', headerName: 'Ações', filterable: false,
            renderCell: (props) => {
                return (
                    <Box >
                        {permissions.change_team && <IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>}
                        {permissions.delete_team && <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>}
                    </Box>
                )
            }
        }
    ]
}

export const loadData = async (setState, permission, setLoader) => {
    if (!permission) {
        toast.error('Você não tem permissão para ver os times')
        return
    }
    const requests = [
        api.get('/team/usernames/'),
    ]
    const [usernames] = await Promise.all(requests)
    const result = {}
    if (usernames.status === 200)
        result.usernames = usernames.data
    setState({ ...result })
}

const Teams = () => {

    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        usernames: [],
        teams: [],
        editRow: null,
        deleteRow: null
    })

    useEffect(() => {
        loadData(setState, user.permissions.view_team, setLoader)
    }, [setLoader, user.permissions.view_team])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        loadData(setState, user.permissions.view_team, setLoader)
        reloadTable()
    }

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o time ${state.deleteRow.name} - ${state.deleteRow.identifier}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditTeamModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    users={state.usernames}
                />
            }
            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.teams}
                        columns={useMemo(()=> columns(setState, user.permissions), [user.permissions])}
                        pagination
                        density='compact'
                        slots={{
                            addComponent: user.permissions.add_team ? () => setState({ editRow: {} }) : null,
                            filterComponent: true,
                            columnComponent: true
                        }}
                        toolbar
                        getURL={url}
                        updateRows={(rows) => setState({'teams': rows})}
                        innerRef={table}
                    />
                </Box>
            </Box>
        </>
    )
}

export default Teams